import React, { useRef, useState, useEffect } from 'react';
import { Link } from "react-router-dom";

// Importar iconos Rojo
import iconoEtiquetas from '../assets/productos/iconos/Etiquetas-Rojo.png';
import iconoMangasTermoencogibles from '../assets/productos/iconos/MangasTemroencogibles-Rojo.png';
import iconoPromocionales from '../assets/productos/iconos/VasosPromocionales-Rojo.png';
import iconoTermoformado from '../assets/productos/iconos/Termoformado-Rojo.png';

import imgAlimentos from '../assets/soluciones-industria/alimentosimg.png';

//Importar iconos Negros
import iconoEtiquetasActive from '../assets/productos/iconos/Etiquetas-Negro.png';
import iconoMangasTermoencogiblesActive from '../assets/productos/iconos/MangasTemroencogibles-Negro.png';
import iconoPromocionalesActive from '../assets/productos/iconos/VasosPromocionales-Negro.png';
import iconoTermoformadoActive from '../assets/productos/iconos/Termoformado-Negro.png';

/*import iconoAlimentosActive from '../assets/inicio/iconos/black/botella-de-agua-Blanco1.png';
import iconoFarmaceuticaActive from '../assets/inicio/iconos/black/frasco-con-cruz-Blanco1.png';
import iconoCosmeticaActive from '../assets/inicio/iconos/black/frasco-cosm-tico-Blanco1.png';
import iconoVinosActive from '../assets/inicio/iconos/black/botella-de-vino-con-Blanco1.png';
import iconoAnimalActive from '../assets/inicio/iconos/black/silueta-de-mascota---frasco-Blanco1.png';
import iconoManufactureraActive from '../assets/inicio/iconos/black/engrane-Blanco2.png';*/

import iconoLista from '../assets/iconos/etiquetaBullet.png';

/**Importar TODAS las Imagenes de productos */
import { getImagesProduct } from "../utils/getImagesProduct";

/*Catergory */
import vasoTransparente from '../assets/productos/vasos-promocionales/vaso-transparente.webp';
import vasoOrangePeel from '../assets/productos/vasos-promocionales/vaso-orange-peel.webp';
import vasoMetalizado from '../assets/productos/vasos-promocionales/vaso-metalizado.webp';
import vasoLisoBrillante from '../assets/productos/vasos-promocionales/vaso-liso-brillante.webp';
import vasoHighGloss from '../assets/productos/vasos-promocionales/vaso-high-gloss.webp';
import vasoColoreable from '../assets/productos/vasos-promocionales/vaso-coloreable.webp';
import vasoTermocromatico from '../assets/productos/vasos-promocionales/vaso-termocromático.webp';
import vasoCafetero from '../assets/productos/vasos-promocionales/vaso-cafetero.webp';
/*Contenido de Soluciones Industriales */
const productos = [
  {
    id: 1,
    nombre: 'Etiquetas',
    hrefname: 'etiquetas',
    nombredescripcion:'Etiquetas',
    icono: iconoEtiquetas,
    iconoActive: iconoEtiquetasActive,
    descripcion: '',
    txt1descripcion: [
      [],
    ],
    txt2descripcion:'',
    enlistado:'Tipos de Etiquetas:',
    caracteristicas: [
      ['Permanentes'], 
      ['Removibles'], 
      ['Reposicionables'],
    ],
    enlistado1:'Tipos de Impresión:',
    caracteristicas1: [
      ['Flexo (Hasta 8 tintas)'], 
      ['Digital (2 F / 7 Dig)'], 
      ['Híbrido'],
    ],
    enlistado2:'Industrias en donde se pueden usar:',
    caracteristicas2: [
      ['Sector Alimentos y Bebidas'], 
      ['Sector Farmacéutico'], 
      ['Sector Animal'],
      ['Sector de Belleza'],
      ['Sector Manufacturero'],
      ['Sector Automotriz'],
    ],
    caracteristicas22: [
      ['Sector Industrial'], 
      ['Sector de Vinos y Licores'], 
      ['Textil'],
      ['Pinturas'],
      ['Otros'],
    ],
    enlistado3:'Características:',
    caracteristicas3: [
      ['Diseños personalizados'], 
      ['Excelente resistencia a la abrasión, el desgaste, temperatura y demás usos que se le den'], 
    ],
    caracteristicas31: [
      ['Puede adaptarse acorde a la necesidad que se requiera y el uso que se vaya a dar'], 
      ['Disponible en rollo o fajilla'], 
    ], 
    section:[
        {
          namesection: 'Etiquetas Transparentes',
          imgsection: getImagesProduct('etiquetas-transparentes'),
        },
        {
          namesection: 'Etiquetas de Seguridad',
          imgsection: getImagesProduct('etiquetas-de-seguridad'),
            
        },
        {
          namesection: 'Etiquetas Booklet',
          imgsection: getImagesProduct('etiquetas-booklet'),
            
        },
        {
          namesection: 'Etiquetas Metalizadas',
          imgsection: getImagesProduct('etiquetas-metalizadas'),
          
        },
        {
          namesection: 'Etiquetas Glow in the Dark',
          imgsection: getImagesProduct('etiquetas-glow-in-the-dark'),
          
        },
        {
          namesection: 'Etiquetas Transferencia Térmica',
          imgsection: getImagesProduct('etiquetas-transferencia-termica'),
          
        },
        {
          namesection: 'Etiquetas Stickers',
          imgsection: getImagesProduct('etiquetas-stickers'),
            
        },
        {
          namesection: 'Etiquetas Resellables',
          imgsection: getImagesProduct('etiquetas-resellables'),
            
        },
        {
          namesection: 'Etiquetas Scratch Off',
          imgsection: getImagesProduct('etiquetas-scratch-off'),
            
        },
        {
          namesection: 'Etiquetas Cold Foil',
          imgsection: getImagesProduct('etiquetas-cold-foil'),
            
        },
        {
          namesection: 'Etiquetas con Aroma',
          imgsection:getImagesProduct('etiquetas-con-aroma'),
        },
        {
          namesection: 'Etiquetas Holográficas',
          imgsection2: getImagesProduct('etiquetas-holograficas'),
            
        },
        {
          namesection: 'Etiquetas Nylon',
          imgsection: getImagesProduct('etiquetas-nylon'),
            
        }
    ],
    category:[],
    img: imgAlimentos,
    img2: imgAlimentos,
    txtbanner:[
      [<strong>¿Tu producto necesita destacar sin comprometer la seguridad?</strong>, ' Cotiza ahora y encuentra la solución exacta.'],
    ],
    txtbtn:'Cotiza ahora'
  },
  {
    id: 2,
    nombre: 'Mangas Termoencogibles',
    hrefname: 'mangas-termoencogibles',
    nombredescripcion:'Mangas Termoencogibles',
    icono: iconoMangasTermoencogibles,
    iconoActive: iconoMangasTermoencogiblesActive,
    descripcion: '',
    txt1descripcion: [
      [],
    ],
    txt2descripcion:'',
    enlistado:'Materiales:',
    caracteristicas: [
      ['PET'], 
      ['PVC'], 
    ],
    enlistado1:'Tipos de Impresión:',
    caracteristicas1: [
      ['Flexo (Hasta 8 tintas)'], 
      ['Digital (2 F / 7 Dig)'], 
      ['Híbrido'],
    ],
    caracteristicas11: [[],],
    enlistado2:'Industrias en donde se pueden usar:',
    caracteristicas2: [
      ['Sector Alimentos y Bebidas'], 
      ['Sector Farmacéutico'], 
      ['Sector Animal'],
      ['Sector de Belleza'],
      ['Sector Manufacturero'],
      ['Sector Automotriz'],
    ],
    caracteristicas22: [
      ['Sector Industrial'], 
      ['Sector de Vinos y Licores'], 
      ['Textil'],
      ['Pinturas'],
      ['Otros'],
    ],
    enlistado3:'Características:',
    caracteristicas3: [
      ['Material termoplástico que se encoge al aplicar calor'], 
      ['Excelente resistencia a la abrasión y el desgaste'], 
    ],
    caracteristicas31: [
      ['Puede ser impresa en frente y reverso o adhesivo'], 
      ['Disponible en rollo o fajilla'], 
    ], 
    section:[
        {
          namesection: '',
          imgsection: getImagesProduct('mangas-termoencogibles'),
        },    
    ],
    category:[],
    img: imgAlimentos,
    img2: imgAlimentos,
    txtbanner:[
      [<strong>¿Necesitas etiquetas seguras y normativas en el mejor tiempo posible?</strong>],
    ],
    txtbtn:'Solicita tu cotización'
  },
  {
    id: 3,
    nombre: 'Vasos Promocionales',
    hrefname: 'vasos-promocionales',
    nombredescripcion:'Vasos Promocionales',
    icono: iconoPromocionales,
    iconoActive: iconoPromocionalesActive,
    descripcion: '',
    txt1descripcion: [
      [],
    ],
    txt2descripcion:'',
    enlistado:'Tipos de Vasos:',
    caracteristicas: [
      ['24 oz para bebidas calientes'], 
      ['32 oz para bebidas frías'], 
      ['C/S TAPA'],
    ],
    enlistado1:'',
    caracteristicas1: [ ],
    enlistado2:'Industrias en donde se pueden usar:',
    caracteristicas2: [
      ['Eventos masivos'], 
      ['Conciertos'], 
      ['Expos'],
      ['Cine'],
    ],
    caracteristicas22: [
      ['Cafeterías'], 
      ['Eventos deportivos'], 
      ['Otros más…'],
    ],
    
    enlistado3:'Características:',
    caracteristicas3: [
      ['Vasos inmold de alta calidad y durabilidad'], 
      ['Diseños personalizados'], 
    ],
    caracteristicas31: [
      ['Opción de incluir tapas para mayor comodidad'], 
      ['Diferentes colores y estilos'], 
    ], 
    section:[],
    category:[
      {
        namesection: 'Vaso Transparente',
        imgsection: vasoTransparente,
      },
      {
        namesection: 'Vaso Orange Peel',
        imgsection: vasoOrangePeel,
      },
      {
        namesection: 'Vaso Metalizado',
        imgsection: vasoMetalizado,
      },
      {
        namesection: 'Vaso Liso Brillante',
        imgsection: vasoLisoBrillante,
      },
      {
        namesection: 'Vaso High Gloss',
        imgsection: vasoHighGloss,
      },
      {
        namesection: 'Vaso Coloreable',
        imgsection: vasoColoreable,
      },
      {
        namesection: 'Vaso Termocromático',
        imgsection: vasoTermocromatico,
      },
      {
        namesection: 'Vaso Cafetero',
        imgsection: vasoCafetero,
      },
    ],
    img: imgAlimentos,
    img2: imgAlimentos,
    txtbanner: [
      ['¿Buscas etiquetas que luzcan premium y duren?'],
    ],
    txtbtn:'Escríbenos'
  },
  {
    id: 4,
    nombre: 'Termoformado',
    nombredescripcion:'Termoformado',
    hrefname: 'termoformado',
    icono: iconoTermoformado,
    iconoActive: iconoTermoformadoActive,
    descripcion: '',
    txt1descripcion: [
      [],
    ],
    txt2descripcion:'',
    enlistado:'Materiales:',
    caracteristicas: [
      ['PET'], 
      ['PVC'], 
    ],
    enlistado1:'Tipos de Fabricaciones:',
    caracteristicas1: [
      ['Bandejas'], 
      ['Tapas'], 
    ],
    caracteristicas11: [],
    enlistado2:'Industrias en donde se pueden usar:',
    caracteristicas2: [
      ['Sector Alimentos y Bebidas'], 
      ['Sector Animal'], 
      ['Sector de Belleza'],
      ['Sector Manufacturero'],
      ['Sector Automotriz'],
    ],
    caracteristicas22: [
      ['Sector Industrial'], 
      ['Sector de Vinos y Licores'], 
      ['Textil'],
      ['Pinturas'],
      ['Otros'],
    ],
    enlistado3:'Características:',
    caracteristicas3: [
      ['Alta calidad y durabilidad'], 
      ['Diseño y fabricación personalizados'], 
    ],
    caracteristicas31: [
      ['Materiales transparentes de alta calidad'], 
    ], 
    section:[
      {
        namesection: '',
        imgsection: getImagesProduct('termoformado'),
      },
    ],
    category:[],
    img: imgAlimentos,
    img2: imgAlimentos,
    txtbanner:[
      ['¿Quieres que tu etiqueta comunique calidad desde el primer vistazo?'],
    ],
    txtbtn: 'Solicita tu cotización'
  },
];

const Productos = () => {
  /*console.log(getImagesProduct('etiquetas-con-aroma'));*/

  const sectionRefs = useRef([]);
  const btnsContainerRef = useRef(null);

  const [hoveredIdx, setHoveredIdx] = useState(null);
  const [activeIdx, setActiveIdx] = useState(0); //  inicia en 0 (primer botón activo)
  //Fue clickeado?
  //const [buttonClicked, setButtonClicked] = useState(false);
  //Hay Scroll
  //const [scrolled, setScrolled] = useState(false);
  //¿Que evento ocurrio?
  //const [eventsOrder, setEventsOrder] = useState(null);
  // El primer botón está activo
  useEffect(() => {
    // Activar el scrollspy manualmente en React
    const bootstrapScrollSpy = new window.bootstrap.ScrollSpy(document.getElementById('scrollspy-container'), {
      target: '#navbar-example3',
      smoothScroll: true,
    });

    return () => {
      bootstrapScrollSpy.dispose(); // Limpiar el scrollspy cuando el componente se desmonta
    };
  }, []);
  //setActiveIdx(null);
  const buttonActive = (idx) => {
    //setTimeout(() => {
      //setActiveIdx(idx);
      if(activeIdx === idx || hoveredIdx === idx){
        return 'active';
      }else{
        return '';
      }
    //}, 50);
    
  };
  // Scroll por click
  const scrollToSection = (idx) => {
    setActiveIdx(idx);
    if (sectionRefs.current[idx]) {
      sectionRefs.current[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (btnsContainerRef.current && window.innerWidth >= 768) {
        
        const btn = btnsContainerRef.current.querySelectorAll('button')[idx];
        if (btn) {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
      
    }
    
  };

  const handleScroll = () => {
    const offsets = sectionRefs.current.map(ref => {
      if (!ref) return Number.POSITIVE_INFINITY;
        const rect = ref.getBoundingClientRect();
      return Math.abs(rect.top - 120); // 120 es el scrollMarginTop  
    });
    const minOffset = Math.min(...offsets);
    const idx = offsets.indexOf(minOffset);
    if (idx !== -1 && idx !== activeIdx) {
      setActiveIdx(idx);
    }
  };
 
  window.addEventListener('scroll', handleScroll, { passive: true });
  //return () => window.removeEventListener('scroll', handleScroll);

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-0">
          {/* Frase de la página */}
          <div className='container-fluid pdg-section-ch'>
            <div className="row align-items-center mb-5">
              <div className="col-12 text-start p-0">
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'60%'}}>
                    <span style={{ color: 'var(--color-principal)'}}>Etiquetas con valor agregado
                    </span> que ofrecen soluciones.
                </h1>  
                <p  className="lightblack" style={{fontWeight:'500', fontSize:'1.5rem'}}>
                  Conoce nuestro catálogo de productos disponibles para tu proyecto.
                </p>     
              </div>
            </div>
          </div>
          {/*Contenido de la página */}
          <div id='productos' className='container-fluid pdg-section-scroll' style={{ background: 'var(--color-text-negro-light)', paddingBottom:'5%'}}>
            <div className="row align-items-start mb-5">
              {/* Botones verticales */}
              <div className="col-12 col-md-3 mb-4 mb-md-0 p-0 d-md-block d-none sticky-industrias">
                <div className='sticky-industrias' style={{position: 'relative'}}>
                  <div id="navbar-example3" className="d-flex flex-column gap-3">
                    {productos.map((producto, idx) => (
                      <a
                        key={producto.id}
                        onClick={() => scrollToSection(idx) }
                        onMouseEnter={() => setHoveredIdx(idx)}   
                        onMouseLeave={() => setHoveredIdx(null)}
                        className={`btn btn-custom btn-wscroll d-flex align-items-center ${buttonActive(idx)}`}
                        aria-label={`Ir a sección ${producto.nombre}`}
                      >
                        <img
                          className='icon-category'
                          src={
                            activeIdx === idx || hoveredIdx === idx  
                            ? producto.iconoActive
                            : producto.icono
                          }
                          alt={producto.nombre}
                        />
                        <span className="btn-txtscroll text-start">{producto.nombre}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              {/* Contenido de cada section */}
              <div className="col-12 col-md-9 p-0">
                <div id="scrollspy-container" className="scrollspy-example-2" tabIndex="0">
                  {productos.map((producto, idx) => (
                    <div    
                      key={producto.id}
                      ref={el => sectionRefs.current[idx] = el}          
                      id={producto.hrefname}
                      className="pb-4 cont-soluciones"
                      style={{
                        scrollMarginTop: '120px',
                        marginBottom: idx === productos.length - 1 ? '0' : '23.5%'
                      }}
                    >
                      <div className='d-block d-md-none d-lg-none'>
                        <img
                          className='icono-soluciones-mobile'
                          src={activeIdx === idx ? producto.icono : producto.icono}
                          alt={producto.nombre}
                        />
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                        <h2 className="mb-0">{producto.nombredescripcion}</h2>
                        {producto.id === 3 && (
                          <Link
                            to="/vasospromocionales"
                            className="btn-descubre-mas"
                            aria-label="Descubre más sobre vasos promocionales"
                          >
                            Descubre Más
                          </Link>
                        )}
                      </div>
                      <div className='container-fluid cont-list '>
                        {/*Primer enlistado */}
                        <div className='container-fluid px-md-auto px-0 py-md-3 py-2'>
                          <p style={{ color: '#fff', fontWeight: '600' }}> {producto.enlistado}</p>
                            <div className='row' style={{ color: '#fff', paddingLeft: '0' }}>
                              {producto.caracteristicas.map((caracteristica, idx2) => (
                                <div key={idx2} className='col-lg-4 col-12'>
                                  <div className='d-flex flex-row'>
                                    <img
                                      className='icono-lista'
                                      src={iconoLista}
                                      alt=""
                                      aria-hidden="true"
                                    />
                                    <p className="m-0">
                                      {Array.isArray(caracteristica)
                                        ? caracteristica.map((c, subIdx) => (
                                          <span key={subIdx}>{c}</span>
                                        ))
                                        : caracteristica}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                        </div>
                        
                        {/*Segundo enlistado */}
                        <div className='container-fluid px-0 py-md-3 py-2'>
                          <p style={{ color: '#fff', fontWeight: '600' }}> {producto.enlistado1}</p>
                            <div className='row' style={{ color: '#fff', listStyle: 'none', paddingLeft: '0' }}>
                                
                                      {producto.caracteristicas1.map((caracteristica, idx2) => (
                                        <div key={idx2} className='col-lg-4 col-12' style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
                                          <img
                                            className='icono-lista'
                                            src={iconoLista}
                                            alt=""
                                            aria-hidden="true"
                                          />
                                          <p className="m-0">
                                            {Array.isArray(caracteristica)
                                              ? caracteristica.map((c, subIdx) => (
                                                <span key={subIdx}>{c}</span>
                                              ))
                                              : caracteristica}
                                          </p>
                                        </div>
                                      ))}
                            </div>
                        </div>
                        {/*Tercer enlistado */}
                        <div className='container-fluid px-0 py-md-3 py-2'>
                          <p style={{ color: '#fff', fontWeight: '600' }}> {producto.enlistado2}</p>
                            <div className='row'>
                                <div className='col-md-6 col-12'>
                                    <ul style={{ color: '#fff', listStyle: 'none', paddingLeft: '0' }}>
                                        {producto.caracteristicas2.map((caracteristica, idx2) => (
                                            <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px',  flexDirection: 'row' }}>
                                                <img
                                                  className='icono-lista'
                                                  src={iconoLista}
                                                  alt=""
                                                  aria-hidden="true"
                                                />
                                                <p className="m-0">
                                                    {Array.isArray(caracteristica)
                                                        ? caracteristica.map((c, subIdx) => (
                                                            <span key={subIdx} style={{ display: 'block' }}>{c}</span>
                                                            ))
                                                        : caracteristica}
                                                </p>
                                            </li>
                                        ))}
                                        </ul>
                                </div>
                                <div className='col-md-6 col-12'>
                                    <ul style={{ color: '#fff', listStyle: 'none', paddingLeft: '0' }}>
                                        {(producto.caracteristicas22 || []).map((caracteristica, idx2) => (
                                            <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
                                                <img
                                                  className='icono-lista'
                                                  src={iconoLista}
                                                  alt=""
                                                  aria-hidden="true"
                                                />
                                                <p className="m-0">
                                                    {Array.isArray(caracteristica)
                                                    ? caracteristica.map((c, subIdx) => (
                                                        <span key={subIdx}>{c}</span>
                                                        ))
                                                    : caracteristica}
                                                </p>
                                            </li>
                                        ))}
                                        </ul>
                                </div>
                            </div>
                        </div>

                        
                        
                        
                        {/*Cuarto enlistado */}
                        
                        <div className='container-fluid px-md-auto px-0 py-md-3 py-2'>
                          <p style={{ color: '#fff', fontWeight: '600' }}> {producto.enlistado3}</p>
                            <div className='row'>
                                <div className='col-md-6 col-12'>
                                    <ul style={{ color: '#fff', listStyle: 'none', paddingLeft: '0' }}>
                                        {producto.caracteristicas3.map((caracteristica, idx2) => (
                                            <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
                                                <img
                                                  className='icono-lista'
                                                    src={iconoLista}
                                                    alt=""
                                                    aria-hidden="true"
                                                />
                                                <p className="m-0">
                                                    {Array.isArray(caracteristica)
                                                    ? caracteristica.map((c, subIdx) => (
                                                        <span key={subIdx}>{c}</span>
                                                        ))
                                                    : caracteristica}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className='col-md-6 col-12'>
                                    <ul style={{ color: '#fff', listStyle: 'none', paddingLeft: '0' }}>
                                            {producto.caracteristicas31.map((caracteristica, idx2) => (
                                                <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
                                                    <img
                                                      className='icono-lista'
                                                        src={iconoLista}
                                                        alt=""
                                                        aria-hidden="true"
                                                    />
                                                    <p className="m-0">
                                                        {Array.isArray(caracteristica)
                                                        ? caracteristica.map((c, subIdx) => (
                                                            <span key={subIdx}>{c}</span>
                                                            ))
                                                        : caracteristica}
                                                    </p>
                                                </li>
                                            ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                      </div>
                    {/**Contenedor dinamico de las imagenes*/}
                    <div className="container-fluid">
                       <div className="mb-4 row">
                        {producto.category.map((sec, idx) => {
                            // Buscar dinámicamente la clave que empiece con "namesection"
                            const nameKey = Object.keys(sec).find((k) => k.startsWith("namesection"));
                            const imagesKey = Object.keys(sec).find((k) => k.startsWith("imgsection"));
                            const titulo = sec[nameKey];
                            const images = sec[imagesKey];
                            {/* !titulo || || titulo === '' */}
                            {/**Acomodado de las imagenes */}
                            if ( !images || images.length === 0 ) return null;
                            return (
                               
                                      <div key={idx} className='col-md-6 col-12 '>
                                        <p style={{ color: "#fff", fontWeight:'600', margin: '0%', padding: '5% 0%' }}>{titulo}</p>
                                        <img
                                            src={images}
                                            alt={`${titulo}`}
                                            className="img-fluid rounded"
                                        />
                                      </div>
                                    
                                
                            );
                        })}  
                        </div>
                    </div>
                    
                    {/**Contenedor dinamico de las imagenes*/}
                    <div className="container-fluid">
                        {producto.section.map((sec, idx) => {
                            // Buscar dinámicamente la clave que empiece con "namesection"
                            const nameKey = Object.keys(sec).find((k) => k.startsWith("namesection"));
                            const imagesKey = Object.keys(sec).find((k) => k.startsWith("imgsection"));
                            const titulo = sec[nameKey];
                            const images = sec[imagesKey];
                            {/* !titulo || || titulo === '' */}
                            {/*if ( !images || images.length === 0 ) return null;

                            return (
                                <div key={idx} className="mb-4">
                                    <p style={{ color: "#fff", marginBottom: "10px", fontWeight:'600' }}>{titulo}</p>
                                    <div className="row">
                                        {images.map((img, i) => (
                                            <div key={i} className="col-12 col-md-4 mb-3">
                                                <img
                                                    src={img}
                                                    alt={`${titulo} ${i + 1}`}
                                                    className="img-fluid rounded"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );*/}
                             if (!images || images.length === 0) return null;

                            const total = images.length;

                            return (
                              <React.Fragment key={idx}>
                                <p style={{ color: "#fff", marginBottom: "10px", fontWeight: "600" }}>
                                  {titulo}
                                </p>
                                <div className='conteiner-fluid'>
                                  <div className='row'>
                                {images.map((img, i) => {
                                  let colClass = "col-12"; // default

                                  if (total % 3 === 0) {
                                    // divisible entre 3 → 3 columnas iguales
                                    colClass = "col-md-4 col-12";
                                  } else if (total === 4) {
                                    // 4 imágenes → 2 columnas por fila
                                    colClass = "col-md-6 col-12";
                                  } else if (total === 5) {
                                    // 5 imágenes → primeras 3 col-md-4, últimas 2 col-md-6
                                    if (i < 3) {
                                      colClass = "col-md-4 col-12";
                                    } else {
                                      colClass = "col-md-6 col-12";
                                    }
                                  }

                                  return (
                                    
                                    <div key={i} className={`${colClass} mb-3 `}>
                                      <img
                                        src={img}
                                        alt={`${titulo}-${i}`}
                                        className="img-fluid rounded"
                                      />
                                    </div>
                                  );
                                })}
                                </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                          </div>
                        
                      {/**Contenido de imagenes */}
                      {/*<div className='container-fluid'>
                        <div className='row'>
                            <p style={{ color: '#fff', fontWeight: '600' }}> {producto.namesection}</p>
                            <p style={{ color: '#fff', fontWeight: '600' }}> {producto.namesection}</p>
                          <div className='col-md-6 col-12 p-md-0 pe-md-3 p-0'>
                            <img src={producto.img} alt={producto.nombre}/>
                          </div>
                          <div className='col-md-6 col-12 p-md-0 p-0 ps-md-3 pt-md-auto pt-3'> 
                            <img src={producto.img2} alt={producto.nombre}/>
                          </div> 
                        </div>
                      </div>*/}
                      
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productos; 